import * as React from 'react';
import bevnetCpgMediaLogo from '@/assets/bevnetcpgmedia.svg';

const LogoBevNetNosh = ({ className, isWhite = false }: { className?: string; isWhite?: boolean }) => (
  <img
    src={bevnetCpgMediaLogo}
    alt="BevNET CPG Media"
    className={className}
    style={{
      filter: isWhite ? 'brightness(0) invert(1)' : undefined
    }}
  />
);

export default LogoBevNetNosh;
